import type { AttachmentDescriptor } from 'flare-chat-core/contracts';
import type { UploadFileInput } from '../../application/chat/contracts';

export const attachmentInput = (file: UploadFileInput): AttachmentDescriptor => {
  const origin = file.originFileObj;
  return {
    uid: String(file.uid), filename: String(file.filename ?? file.name ?? origin?.name ?? ''),
    mime_type: String(file.mime_type ?? file.type ?? origin?.type ?? ''), size: file.size ?? origin?.size,
    ...(file.source_id ? { source_id: file.source_id } : { uploadHandle: origin ?? (file instanceof Blob ? file : undefined) }),
  };
};
